/*
  owner 2026-09-17: tap the card's play arrow -> the product's YouTube Shorts
  video opens in a popup, without leaving the collection page.

  Notes for whoever touches this next:
  - The arrow lives INSIDE the card, and the whole card is a link. The click is
    caught in the CAPTURE phase and stopped there, so the card link never fires.
  - Nothing about YouTube is loaded until the first tap. The iframe is created on
    open and destroyed on close, which is also what stops the audio.
  - Shorts are vertical, so the frame is 9:16. A normal 16:9 video will letterbox
    inside it rather than crop.
*/
(function () {
  'use strict';

  // card-product.liquid emits this tag once per section that renders a card with
  // skip_styles false, so on the homepage the file runs about five times. Without
  // this guard each run adds its own click listener and one tap opens five popups.
  if (window.__smVideoInit) return;
  window.__smVideoInit = true;

  var SRC = 'https://www.youtube-nocookie.com/embed/';

  // owner 2026-09-17: the arrow on product cards was never instrumented, so
  // there was no way to answer "does anyone actually tap it". GA4 is already on
  // every page via Shopify's Google channel, so this costs no extra script -
  // one beacon, only when someone taps.
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) { /* analytics must never break the popup */ }
  }
  var overlay = null;
  var frameWrap = null;
  var lastFocus = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'sm-video-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product video');
    overlay.hidden = true;

    overlay.innerHTML =
      '<div class="sm-video-modal__box">' +
      '<button type="button" class="sm-video-modal__close" aria-label="Close video">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg></button>' +
      '<div class="sm-video-modal__frame"></div>' +
      '</div>';

    frameWrap = overlay.querySelector('.sm-video-modal__frame');

    overlay.addEventListener('click', function (e) {
      // a tap on the backdrop (not the video box) closes
      if (e.target === overlay) close();
    });
    overlay.querySelector('.sm-video-modal__close').addEventListener('click', close);

    document.body.appendChild(overlay);
  }

  function open(id) {
    if (!overlay) build();
    lastFocus = document.activeElement;

    var iframe = document.createElement('iframe');
    iframe.src = SRC + encodeURIComponent(id) +
      // mute=1 is NOT optional: browsers refuse autoplay WITH SOUND, so without
      // it the player loaded and then sat on a black frame until the shopper
      // guessed to tap the video itself. Muted autoplay is always allowed, and
      // YouTube's own unmute button is right there in the player.
      '?autoplay=1&mute=1&playsinline=1&rel=0&modestbranding=1';
    iframe.title = 'Product video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    frameWrap.appendChild(iframe);

    overlay.hidden = false;
    openedAt = Date.now();
    document.documentElement.classList.add('sm-video-open');
    overlay.querySelector('.sm-video-modal__close').focus();
    document.addEventListener('keydown', onKey);
  }

  var openedAt = 0;
  function close() {
    if (!overlay || overlay.hidden) return;
    track('card_video_close', { seconds: Math.round((Date.now() - openedAt) / 1000) });
    overlay.hidden = true;
    frameWrap.innerHTML = '';                 // this is what stops playback
    document.documentElement.classList.remove('sm-video-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  }

  // capture phase: the arrow sits inside the card link, so the click has to be
  // taken before the link sees it
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sm-video]') : null;
    if (!btn) return;
    var id = btn.getAttribute('data-sm-video');
    if (!id) return;
    e.preventDefault();
    e.stopPropagation();
    track('card_video_open', {
      item_id: id,
      item_name: btn.getAttribute('aria-label') || '',
      page_type: document.body.className.indexOf('template-index') > -1 ? 'home' : 'other'
    });
    // The arrow sits inside the card, so the card's own link is the product
    // this video belongs to. sm-video-attribution.js carries it to the order.
    try {
      var card = btn.closest('.card-wrapper, .card, li, .grid__item');
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      document.dispatchEvent(new CustomEvent('sm:video-product-click', {
        detail: {
          video: id,
          title: btn.getAttribute('aria-label') || '',
          url: link ? link.getAttribute('href') : '',
          placement: 'product card'
        }
      }));
    } catch (e) {}
    open(id);
  }, true);
})();
